import { EnvironmentType } from '../../environments/types';

// Helper to determine provider type for breadcrumbs
export function getRegistriesLink(endpoint?: { Type?: number }) {
  switch (endpoint?.Type) {
    case EnvironmentType.AgentOnKubernetes:
    case EnvironmentType.KubernetesLocal:
    case EnvironmentType.EdgeAgentOnKubernetes:
      return 'kubernetes.registries';
    case EnvironmentType.Docker:
    case EnvironmentType.AgentOnDocker:
    case EnvironmentType.EdgeAgentOnDocker:
      // Swarm detection is not possible here without extra info, so default to docker
      return 'docker.host.registries';
    case EnvironmentType.Azure:
      return 'portainer.registries';
    case undefined:
    default:
      return 'portainer.registries';
  }
}
